import { Injectable, OnDestroy } from '@angular/core';
import { OrgEntityService } from '@app/shared/services/org-entity.service';
import { Rock } from '@entities/rock';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { State } from '@app/app.state';
import { EntityService } from '@app/shared/services/entity.service';
import { getOrganizationId } from '@app/user-org/state/user-org.selectors';
import { COLLECTION_NAMES } from '@app/shared/services/collection-names';
import { PermissionedEntity } from '@app/shared/interfaces/permissioned-entity.interface';
import { WhereFilterOp, where } from '@angular/fire/firestore';
import { PermissionsFacade } from '@app/shared/state/permissions.facade';
import { AppAreas } from '@entities/enums/app-areas';

@Injectable()
export class RockService implements EntityService<Rock>, PermissionedEntity, OnDestroy {
   entities$: Observable<Rock[]>;

   readonly COLLECTION_NAME = COLLECTION_NAMES.ROCKS;
   private orgId$: Observable<string> = this.store.pipe(select(getOrganizationId));
   private orgEntityService = new OrgEntityService<Rock>();
   private teamMemberId$ = this.permissionsFacade.currentUserTeamMemberId$;
   private permissionGroup$ = this.permissionsFacade.currentUserPermissionGroup$;

   constructor(private store: Store<State>, private permissionsFacade: PermissionsFacade) {
      this.orgEntityService.init(
         this.orgId$,
         this.COLLECTION_NAME,
         AppAreas.Evolve,
         this.permissionGroup$,
         this.assigneeFilter,
         this.teamMemberId$
      );
      this.entities$ = this.orgEntityService.entities$;
   }
   ngOnDestroy() {
      this.orgEntityService.destroy();
   }
   save(entity: Rock, options?: { overwrite?: boolean; orgId?: string }): Promise<Rock> {
      return this.orgEntityService.save(entity, options);
   }
   batchSave(entities: Rock[]): Promise<Rock[]> {
      return this.orgEntityService.batchSave(entities);
   }
   delete(entity: Rock): Promise<void> {
      return this.orgEntityService.delete(entity);
   }

   assigneeFilter(teamMemberId: string): Array<[string, WhereFilterOp, string]> {
      return [['assigneeId', '==', teamMemberId]];
   }
}
